import { CRM_PERM } from "../../CRMOfficeCaller/shared/crmPermissions";

/* ────────────────────────────────────────────────────────────
 * pushSetup — who may open Communication > Push Notifications, and
 * where its data comes from (QA CM-11). No React in here.
 *
 * The page lists the push queue of the organisation's CRM node
 * (GET {CRMUrlNode}api/push-campaigns). The request carries no org
 * id, so the CRM host is the only thing that scopes it: an
 * organisation without one has no push data at all.
 * ──────────────────────────────────────────────────────────── */

/**
 * The signed-in organisation's CRM node URL (with a trailing slash), or
 * null when it has none.
 *
 * The same test as crmNodeBase() in ApiConfig.js but WITHOUT its fallback
 * to the shared BASE_URL_CHATADMIN host: falling back here would list —
 * and offer to delete — another organisation's push queue. Rejects '',
 * '/', 'undefined/' and 'null/' (a login response without the field
 * stores "undefined/").
 */
export const crmNodeUrlOrNull = (raw) => {
  const s = typeof raw === "string" ? raw.trim() : "";
  if (!/^https?:\/\//i.test(s)) return null;
  return s.endsWith("/") ? s : `${s}/`;
};

// The push-specific right the backend already seeds, or the CRM master
// right — not "View Chat", which every chat user has.
export const PUSH_PAGE_PERMISSIONS = [
  CRM_PERM.VIEW_PUSH_NOTIFICATION,
  "View CRM Office Caller",
];

// The same paths as ApiConfig's GET_PUSH_NOTIFICATIONS and
// BULK_DELETE_PUSH_NOTIFICATIONS, built at call time from the signed-in
// user's CRM URL: those constants are frozen when the module first loads,
// so they kept the previous organisation's host after a logout and login
// in the same tab.
export const pushCampaignsUrl = (base) => `${base}api/push-campaigns`;
export const pushCampaignUrl = (base, id) => `${base}api/push-campaigns/${id}`;
export const pushBulkDeleteUrl = (base) => `${base}api/push-campaigns/bulk-delete`;
